import { createAction } from '@ngrx/store';

export const CloseWebView = createAction('[Webview] Close');

export const OpenContactWebView = createAction('[Webview] Open Contact');
